/* eslint-disable no-underscore-dangle */
import { Chakra } from "@airhelp/react-ui-components";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { accordionHeaderStyles, accordionContentStyles } from "./Accordion.styles";
import type { AccordionProps } from "./Accordion.d";

const {
  AccordionItem,
  AccordionButton,
  Flex,
  AccordionIcon,
  AccordionPanel,
  Accordion: ChakraAccordion,
} = Chakra;

const Accordion = ({
  items,
  icons: { close, open } = {
    close: <AccordionIcon color="primary.500" />,
    open: <AccordionIcon color="primary.500" />,
  },
  variant = "primary",
}: AccordionProps) => {
  const accordionItems =
    items &&
    items.map((item) => (
      <AccordionItem key={item._uid} boxShadow="none">
        {({ isExpanded }) => (
          <>
            <AccordionButton>
              <Flex
                justify="space-between"
                textAlign="left"
                align={{ mobile: "flex-start", lg: "center" }}
                w="full"
              >
                <RichtextAdapter content={item.header} customStyles={accordionHeaderStyles} />
                {isExpanded ? close : open}
              </Flex>
            </AccordionButton>
            <AccordionPanel>
              <RichtextAdapter content={item.body} customStyles={accordionContentStyles} />
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    ));

  return (
    <ChakraAccordion variant={variant} allowToggle>
      {accordionItems}
    </ChakraAccordion>
  );
};

export default Accordion;
